import { RxDotFilled } from "react-icons/rx";
import styles from "../../../styles/Components/faq/GeneralQuestions.module.css";

const FaqItem = ({ question, answer, id }) => {
  return (
    <li className={styles.FaqItem} id={`q${id}`}>
      <h3 style={{ display: "flex", alignItems: "center" }}>
        <RxDotFilled />
        {question}
      </h3>
      <p className={styles.answer}>
        {question === "How profitable are your AI predictions?" ? (
          <>
            Our AI predictions have consistently shown to generate highly
            profitable signals when compared to other methods. It's important to
            note that profitability can vary over time and across different time
            frames. For more detailed information, we encourage you to refer to{" "}
            <a
              href="https://cryptocrispy.com.au/reports.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              our accuracy report
            </a>{" "}
            , which provides insights into the performance of our AI predictions
            and their profitability.
          </>
        ) : (
          answer
        )}
      </p>
    </li>
  );
};

export default FaqItem;
